import { useEffect, useState } from 'react'

import { loadState, saveState } from 'utils/localStorage'

export const useLocalStorage = <T>(
  key: string,
  defaultValue: T,
  noUpdate?: boolean,
): [T, React.Dispatch<React.SetStateAction<T>>, boolean] => {
  const [hydrated, setHydrated] = useState(false)
  const [value, setValue] = useState<T>(defaultValue)

  useEffect(() => {
    const setInitialValue = async () => {
      const state = await loadState(key)
      const newState = state !== undefined ? state : defaultValue
      if (!noUpdate && state !== null) {
        setValue(newState)
      }
      setHydrated(true)
    }

    setInitialValue()
  }, [defaultValue, key, noUpdate])

  useEffect(() => {
    // storing input name
    if (!noUpdate) {
      saveState(key, value)
    }
  }, [key, noUpdate, value])

  return [value, setValue, hydrated]
}
